module.exports = __webpack_public_path__ + "static/media/mamma_mobile.ecb7eb50.jpg";